import { render } from "./CRMContactsPage.vue?vue&type=template&id=cc37f7ec&ts=true"
import script from "./CRMContactsPage.vue?vue&type=script&lang=ts"
export * from "./CRMContactsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__